import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";


interface Props {
  serviceType: "kaikei" | "shokokai"; // 1: 会計事務所, 2: 商工会
  completeType: "connect" | "disconnect"; // 連携完了 or 解除完了
  onTapCloseModal: () => void;
}

// ログイン画面で利用している「パスワードを忘れた方、お困りの方はこちら」モーダル
export const ConnectDisconnectCompleted = ({ serviceType, completeType, onTapCloseModal }: Props) => {

  const connectCompleteMessage = "との連携を開始しました。";
  const disconnectCompleteMessage = "との連携を解除しました。";
  const remarkMessage = "※以後、明細が更新されるたびに、自動でWeb明細帳情報が連携サービスへ送信されます。";
  const serviceName = serviceType === "kaikei" ? "会計事務所クラウド" : "商工会クラウド";

  return (
    <BasePageModal
      title="操作が完了しました"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="閉じる"
          onClick={onTapCloseModal}
        />
      }
    >
      <p>
        {completeType === "connect" ? `${serviceName}${connectCompleteMessage}` : `${serviceName}${disconnectCompleteMessage}`}
      </p>
      <p>
        {completeType === "connect" && remarkMessage}
      </p>
    </BasePageModal>
  );
};
